<template>
    <Component :is="component" :size="normalizedSize" :color="normalizedColor" :filled="filled" />
</template>

<script>
import _ from 'lodash';
import VueTypes from 'vue-types';

import { lsColors } from '@/constants';
import { LsIconTypes, LsIconSizes } from './LsIcon.constants';
import AddSVG from './components/AddSVG.vue';
import AndroidSVG from './components/AndroidSVG.vue';
import CalendarSVG from './components/CalendarSVG.vue';
import CancelSVG from './components/CancelSVG.vue';
import ChatSVG from './components/ChatSVG.vue';
import CheckmarkSVG from './components/CheckmarkSVG.vue';
import CheckoutlineSVG from './components/CheckOutlineSVG.vue';
import CloseoutlineSVG from './components/CloseOutlineSVG.vue';
import ChevronSVG from './components/ChevronSVG.vue';
import CloseSVG from './components/CloseSVG.vue';
import CopySVG from './components/CopySVG.vue';
import DashesSVG from './components/DashesSVG.vue';
import DeleteSVG from './components/DeleteSVG.vue';
import DragSVG from './components/DragSVG.vue';
import EditSVG from './components/EditSVG.vue';
import EmailSVG from './components/EmailSVG.vue';
import HamburgerSVG from './components/HamburgerSVG.vue';
import HideSVG from './components/HideSVG.vue';
import HourglassSVG from './components/HourglassSVG.vue';
import IosSVG from './components/IosSVG.vue';
import MobileSVG from './components/MobileSVG.vue';
import MoreSVG from './components/MoreSVG.vue';
import OtcSVG from './components/OtcSVG.vue';
import PinSVG from './components/PinSVG.vue';
import QuoteSVG from './components/QuoteSVG.vue';
import RatingsSVG from './components/RatingsSVG.vue';
import SkipSVG from './components/SkipSVG.vue';
import SmsSVG from './components/SmsSVG.vue';
import StarSVG from './components/StarSVG.vue';
import TimeSVG from './components/TimeSVG.vue';
import UserSVG from './components/UserSVG.vue';
import ViewSVG from './components/ViewSVG.vue';

export default {
    name: 'LsIcon',
    components: {
        AddSVG,
        AndroidSVG,
        CalendarSVG,
        CancelSVG,
        ChatSVG,
        CheckmarkSVG,
        CheckoutlineSVG,
        ChevronSVG,
        CloseSVG,
        CloseoutlineSVG,
        CopySVG,
        DashesSVG,
        DeleteSVG,
        DragSVG,
        EditSVG,
        EmailSVG,
        HamburgerSVG,
        HideSVG,
        HourglassSVG,
        IosSVG,
        MobileSVG,
        MoreSVG,
        OtcSVG,
        PinSVG,
        QuoteSVG,
        RatingsSVG,
        SkipSVG,
        SmsSVG,
        StarSVG,
        TimeSVG,
        UserSVG,
        ViewSVG,
    },
    props: {
        type: {
            type: String,
            required: true,
            validator(value) {
                return _.includes(LsIconTypes, value);
            },
        },
        color: {
            type: String,
            default: 'primary',
            validator(value) {
                return _.includes(_.keys(lsColors), value);
            },
        },
        size: {
            type: String,
            default: 'sm',
            validator(value) {
                return _.includes(_.keys(LsIconSizes), value);
            },
        },
        sizeOverride: VueTypes.integer,
        filled: VueTypes.bool.def(false),
    },
    computed: {
        normalizedSize() {
            return this.sizeOverride || LsIconSizes[this.size];
        },
        normalizedColor() {
            return lsColors[this.color];
        },
        component() {
            return _.get(this.$options.components, `${_.startCase(this.type)}SVG`);
        },
    },
};
</script>

<style></style>
